import { MaskText, FadeIn } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    label: "La Storia",
    title: "Negli antichi alloggi di Palazzo Martinengo",
    body: "La pizzeria nasce negli ambienti tradizionalmente identificati come gli antichi alloggi di servizio di Palazzo Martinengo di Villagana. Spazi un tempo legati alla vita quotidiana della tenuta tornano oggi ad accogliere persone, cucina e convivialità, conservando il rapporto con la storia del palazzo e con il territorio dell'Oglio.",
  },
  {
    n: "02",
    label: "La Pizza",
    title: "Sottilissima, 42 cm, leggera",
    body: "La nostra pizza è sottilissima e larga 42 cm: un disco croccante e generoso, particolarmente leggero e digeribile. Pensata per essere gustata fino all'ultimo morso, senza appesantire.",
  },
  {
    n: "03",
    label: "La Proposta",
    title: "Pizza, birra e smash burger",
    body: "Una proposta semplice e schietta. Oltre alla pizza serviamo veri smash burger, cotti alla piastra e accompagnati da patatine, e una selezione di birre. Pizza, birra e smash burger: tutto qui.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="locale"
      data-testid="manifesto"
      className="relative mx-auto max-w-[1600px] px-5 md:px-10 py-28 md:py-44"
    >
      <div className="grid md:grid-cols-12 gap-y-10 md:gap-x-10 mb-20 md:mb-32">
        <div className="md:col-span-3">
          <FadeIn>
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[var(--fg-dim)]">
              — Il Locale
            </span>
          </FadeIn>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
            <MaskText
              lines={[
                "Un luogo con",
                <span key="i" className="italic font-light text-[var(--fg-dim)]">
                  una storia.
                </span>,
              ]}
            />
          </h2>
        </div>
      </div>

      <div className="flex flex-col">
        {CHAPTERS.map((c, i) => (
          <FadeIn key={c.n} delay={i * 0.05}>
            <div className="grid md:grid-cols-12 gap-4 md:gap-10 py-10 md:py-14 border-t border-[var(--line)]">
              <div className="md:col-span-3 flex items-baseline gap-4">
                <span className="font-mono text-sm text-[var(--fg-dim)]">{c.n}</span>
                <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[var(--fg-dim)]">
                  {c.label}
                </span>
              </div>
              <h3 className="md:col-span-5 font-serif text-3xl md:text-4xl lg:text-5xl leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-4 text-[var(--fg-dim)] text-sm md:text-base leading-relaxed md:pt-3">
                {c.body}
              </p>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
};
